import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  IconButton,
  DialogContentText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { CardProcess, Header } from '~/components';
import { Routing } from '~/routes/routing';
import { observer, useStores } from '~/utils';
import {
  Childrens,
  Content,
  IconStyled,
  SectionCards,
  SectionTitle,
  Title,
} from './process.styles';

const Process: FC = (): JSX.Element => {
  const { user, routing, process, executions } = useStores();

  const [isModalOpen, setModalOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [selectedMass, setSelectedMass] = useState<ExecutionsType.TestDataResponseAPI | null>(null);

  const goBack = () => routing.back();

  const onSettings = () => {
    routing.push(Routing.SETTINGS);
  };

  const onHome = () => {
    routing.push(Routing.HOME);
  };

  const onSelectSubProcess = (prc: ProcessType.Data) => {
    if (!prc.sub_process.length) return;
    process.setProcess(prc);
    routing.push(Routing.SUBPROCESS, { title: prc.name });
  };

  const fetchData = async () => {
    try {
      await executions.listAllTestData(); // Certifique-se de que as massas de dados são atualizadas corretamente
    } catch (error) {
      console.error('Erro ao carregar as massas de dados:', error);
    }
  };

  useEffect(() => {
    process.list();
    fetchData();
    process.setClient(process.tab[0]);
  }, [executions, process]);

  const openQuantityModal = (mass: ExecutionsType.TestDataResponseAPI) => {
    setSelectedMass(mass);
    setModalOpen(true);
  };

  const executeNoScriptDataMass = async () => {
    if (!selectedMass) return;
    try {
      await executions.consumeTestData(quantity, selectedMass.id);
      setModalOpen(false);
      setQuantity(1);
      setSelectedMass(null);
      await fetchData(); // Atualiza os dados após a execução
      onHome();
    } catch (error) {
      console.error('Erro ao executar a massa de dados:', error);
    }
  };

  return (
    <Content>
      <Header title='TDM' />

      <Childrens>
        <SectionTitle>
          <div style={{ alignItems: 'center' }}>
            <IconStyled onClick={goBack}>arrow_back</IconStyled>
            <Title>Categoria</Title>
          </div>

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={process.client[0]} onChange={(_, newValue) => process.setClient(newValue)}>
              {process.tab.map((client) => (
                <Tab key={client} label={client} value={client} />
              ))}
            </Tabs>
          </Box>
        </SectionTitle>

        <SectionTitle>
          <Title>Processos com Scripts</Title>
        </SectionTitle>
        <SectionCards>
          {process.data
            .filter((e) => e.cliente.includes(process.selectedClient))
            .map(({ description, name, repository_name, sub_process, uid, cliente, _id, external }) => (
              <CardProcess
                titleBtn="Iniciar"
                key={uid || _id}
                onExecute={() =>
                  onSelectSubProcess({
                    _id,
                    description,
                    name,
                    repository_name,
                    sub_process,
                    uid,
                    cliente,
                    external,
                  })
                }
                title={name}
                description={description}
              />
            ))}
        </SectionCards>

        <SectionTitle>
          <Title>Consumo de Massa de Dados</Title>
        </SectionTitle>
        <SectionCards>
          {executions.testData.map((mass) => (
            <CardProcess
              key={mass.id}
              title={mass.name}
              description={mass.description || 'Sem descrição'}
              onExecute={() => openQuantityModal(mass)}
              titleBtn="Executar"
            />
          ))}
        </SectionCards>

        <Dialog
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: {
              padding: '20px',
              borderRadius: '10px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
              margin: '70vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            },
          }}
          BackdropProps={{
            style: { backgroundColor: 'rgba(0, 0, 0, 0.5)', width: '100vw', height: '100vh' },
          }}
        >
          <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>Consumir Massa de Dados</span>
            <IconButton onClick={() => setModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: '20px', color: '#5f6368' }}>
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Quantidade"
              type="number"
              fullWidth
              variant="outlined"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
              inputProps={{ min: 1 }}
            />
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button
              onClick={executeNoScriptDataMass}
              variant="contained"
              color="primary"
              style={{ width: '100%', backgroundColor: '#00244C', color: '#fff', fontWeight: 'bold', height: '50px', borderRadius: '10px' }}
            >
              Iniciar
            </Button>
          </DialogActions>
        </Dialog>
      </Childrens>
    </Content>
  );
};
export default observer(Process);